export const findRows = (photoQty, i, smAndDown) => {
  switch (i) {
    case 0:
      return smAndDown ? (photoQty === 1 || photoQty === 2 ? 2 : 1) : lgSizeFindRows(photoQty, i);
    case 1:
      return smAndDown ? (photoQty === 2 ? 2 : 1) : lgSizeFindRows(photoQty, i);
    case 2:
      return smAndDown ? (photoQty === 4 ? 1 : 2) : lgSizeFindRows(photoQty, i);
    case 3:
    case 4:
      return smAndDown ? 1 : lgSizeFindRows(photoQty, i);
    case 5:
      return smAndDown ? 2 : lgSizeFindRows(photoQty, i);
    case 6:
      return smAndDown ? (photoQty === 7 ? 2 : 1) : lgSizeFindRows(photoQty, i);
    case 7:
      return smAndDown ? 1 : lgSizeFindRows(photoQty, i);
    case 8:
      return smAndDown ? 2 : lgSizeFindRows(photoQty, i);
    default:
      return 1;
  }
};

const lgSizeFindRows = (photoQty, i) => {
  switch (photoQty) {
    case 9:
      return i > 5 ? 2 : 1;
    case 8:
      return i > 4 ? 5 : 3;
    case 7:
      return i > 3 ? 9 : 6;
    case 6:
    case 5:
    case 4:
    case 3:
      return 1;
    case 2:
    case 1:
      return 2;
    default:
  }
};

export const findCols = (photoQty, i, smAndDown) => {
  switch (i) {
    case 0:
      return smAndDown ? (photoQty === 1 || photoQty === 2 ? 2 : 1) : lgSizeFindCols(photoQty, i);
    case 1:
      return smAndDown ? (photoQty === 2 ? 2 : 1) : lgSizeFindCols(photoQty, i);
    case 2:
      return smAndDown ? (photoQty === 4 ? 1 : 2) : lgSizeFindCols(photoQty, i);
    case 3:
    case 4:
      return smAndDown ? 1 : lgSizeFindCols(photoQty, i);
    case 5:
      return smAndDown ? 2 : lgSizeFindCols(photoQty, i);
    case 6:
      return smAndDown ? (photoQty === 7 ? 2 : 1) : lgSizeFindCols(photoQty, i);
    case 7:
      return smAndDown ? 1 : lgSizeFindCols(photoQty, i);
    case 8:
      return smAndDown ? 2 : lgSizeFindCols(photoQty, i);
    default:
      return 1;
  }
};

const lgSizeFindCols = (photoQty, i) => {
  switch (photoQty) {
    case 9:
      return i > 5 ? 2 : 1;
    case 8:
      return i > 4 ? 5 : 3;
    case 7:
      return i > 3 ? 4 : 3;
    default:
      return 1;
  }
};
